import Instance from "../../utils/apiNip";
import responseHandler2 from "../../utils/responseHandler2";
import Storage from "../../utils/storage";
import types from "./types";

export const getNameEnquiryStart = () => ({
  type: types.GET_NAME_ENQUIRY_START,
});

export const getNameEnquirySuccess = (payload) => ({
  type: types.GET_NAME_ENQUIRY_SUCCESS,
  payload,
});

export const getNameEnquiryFailure = (payload) => ({
  type: types.GET_NAME_ENQUIRY_FAILURE,
  payload,
});

export const sendMandateAdviceStart = () => ({
  type: types.SEND_MANDATE_ADVICE_START,
});

export const sendMandateAdviceSuccess = (payload) => ({
  type: types.SEND_MANDATE_ADVICE_SUCCESS,
  payload,
});

export const sendMandateAdviceFailure = (payload) => ({
  type: types.SEND_MANDATE_ADVICE_FAILURE,
  payload,
});

export const sendBalanceEnquiryStart = () => ({
  type: types.SEND_BALANCE_ENQUIRY_START,
});

export const sendBalanceEnquirySuccess = (payload) => ({
  type: types.SEND_BALANCE_ENQUIRY_SUCCESS,
  payload,
});

export const sendBalanceEnquiryFailure = (payload) => ({
  type: types.SEND_BALANCE_ENQUIRY_FAILURE,
  payload,
});

export const sendFundTransferDcStart = () => ({
  type: types.SEND_FUND_TRANSFER_DC_START,
});

export const sendFundTransferDcSuccess = (payload) => ({
  type: types.SEND_FUND_TRANSFER_DC_SUCCESS,
  payload,
});

export const sendFundTransferDcFailure = (payload) => ({
  type: types.SEND_FUND_TRANSFER_DC_FAILURE,
  payload,
});

export const sendFundTransferAdviceDcStart = () => ({
  type: types.SEND_FUND_TRANSFER_ADVICE_DC_START,
});

export const sendFundTransferAdviceDcSuccess = (payload) => ({
  type: types.SEND_FUND_TRANSFER_ADVICE_DC_SUCCESS,
  payload,
});

export const sendFundTransferAdviceDcFailure = (payload) => ({
  type: types.SEND_FUND_TRANSFER_ADVICE_DC_FAILURE,
  payload,
});

export const sendFundTransferDdStart = () => ({
  type: types.SEND_FUND_TRANSFER_DD_START,
});

export const sendFundTransferDdSuccess = (payload) => ({
  type: types.SEND_FUND_TRANSFER_DD_SUCCESS,
  payload,
});

export const sendFundTransferDdFailure = (payload) => ({
  type: types.SEND_FUND_TRANSFER_DD_FAILURE,
  payload,
});

export const sendFundTransferAdviceDdStart = () => ({
  type: types.SEND_FUND_TRANSFER_ADVICE_DD_START,
});

export const sendFundTransferAdviceDdSuccess = (payload) => ({
  type: types.SEND_FUND_TRANSFER_ADVICE_DD_SUCCESS,
  payload,
});

export const sendFundTransferAdviceDdFailure = (payload) => ({
  type: types.SEND_FUND_TRANSFER_ADVICE_DD_FAILURE,
  payload,
});

export const sendAmountBlockStart = () => ({
  type: types.SEND_AMOUNT_BLOCK_START,
});

export const sendAmountBlockSuccess = (payload) => ({
  type: types.SEND_AMOUNT_BLOCK_SUCCESS,
  payload,
});

export const sendAmountBlockFailure = (payload) => ({
  type: types.SEND_AMOUNT_BLOCK_FAILURE,
  payload,
});

export const sendAccountBlockStart = () => ({
  type: types.SEND_ACCOUNT_BLOCK_START,
});

export const sendAccountBlockSuccess = (payload) => ({
  type: types.SEND_ACCOUNT_BLOCK_SUCCESS,
  payload,
});

export const sendAccountBlockFailure = (payload) => ({
  type: types.SEND_ACCOUNT_BLOCK_FAILURE,
  payload,
});

export const getFinancialListStart = () => ({
  type: types.GET_FINANCIAL_LIST_START,
});

export const getFinancialListSuccess = (payload) => ({
  type: types.GET_FINANCIAL_LIST_SUCCESS,
  payload,
});

export const getFinancialListFailure = (payload) => ({
  type: types.GET_FINANCIAL_LIST_FAILURE,
  payload,
});

export const clearInwardInteractionState = () => ({
  type: types.CLEAR_INWARD_INTERACTION_STATE,
});

export const getNameEnquiry = () => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(getNameEnquiryStart());
  API.get("sandbox/interaction/inward/name-inquiry").then((response) => {
    const { data, ok } = response;
    responseHandler2(response);
    if (ok) {
      dispatch(getNameEnquirySuccess(data.data));
    } else {
      dispatch(getNameEnquiryFailure(data));
    }
  });
};

export const sendMandateAdvice = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(sendMandateAdviceStart());
  API.post("sandbox/interaction/inward/mandate-advice", payload).then(
    (response) => {
      const { data, ok } = response;
      responseHandler2(response);
      if (ok) {
        dispatch(sendMandateAdviceSuccess(data.data));
      } else {
        dispatch(sendMandateAdviceFailure(data));
      }
    }
  );
};

export const sendBalanceEnquiry = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(sendBalanceEnquiryStart());
  API.post("sandbox/interaction/inward/balance-enquiry", payload).then(
    (response) => {
      const { data, ok } = response;
      responseHandler2(response);
      if (ok) {
        dispatch(sendBalanceEnquirySuccess(data.data));
      } else {
        dispatch(sendBalanceEnquiryFailure(data));
      }
    }
  );
};

export const sendFundTransferDc = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(sendFundTransferDcStart());
  API.post(
    "sandbox/interaction/inward/funds-transfer-direct-credit",
    payload
  ).then((response) => {
    const { data, ok } = response;
    responseHandler2(response);
    if (ok) {
      dispatch(sendFundTransferDcSuccess(data.data));
    } else {
      dispatch(sendFundTransferDcFailure(data));
    }
  });
};

export const sendFundTransferAdviceDc = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(sendFundTransferAdviceDcStart());
  API.post(
    "sandbox/interaction/inward/funds-transfer-advice-direct-credit",
    payload
  ).then((response) => {
    const { data, ok } = response;
    responseHandler2(response);
    if (ok) {
      dispatch(sendFundTransferAdviceDcSuccess(data.data));
    } else {
      dispatch(sendFundTransferAdviceDcFailure(data));
    }
  });
};

export const sendFundTransferDd = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(sendFundTransferDdStart());
  API.post(
    "sandbox/interaction/inward/funds-transfer-direct-debit",
    payload
  ).then((response) => {
    const { data, ok } = response;
    responseHandler2(response);
    if (ok) {
      dispatch(sendFundTransferDdSuccess(data.data));
    } else {
      dispatch(sendFundTransferDdFailure(data));
    }
  });
};

export const sendFundTransferAdviceDd = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(sendFundTransferAdviceDdStart());
  API.post(
    "sandbox/interaction/inward/funds-transfer-advice-direct-debit",
    payload
  ).then((response) => {
    const { data, ok } = response;
    responseHandler2(response);
    if (ok) {
      dispatch(sendFundTransferAdviceDdSuccess(data.data));
    } else {
      dispatch(sendFundTransferAdviceDdFailure(data));
    }
  });
};

export const sendAmountBlock = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(sendAmountBlockStart());
  API.post("sandbox/interaction/inward/amount-block-unblock", payload).then(
    (response) => {
      const { data, ok } = response;
      responseHandler2(response);
      if (ok) {
        dispatch(sendAmountBlockSuccess(data.data));
      } else {
        dispatch(sendAmountBlockFailure(data));
      }
    }
  );
};

export const sendAccountBlock = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(sendAccountBlockStart());
  API.post("sandbox/interaction/inward/account-block-unblock", payload).then(
    (response) => {
      const { data, ok } = response;
      responseHandler2(response);
      if (ok) {
        dispatch(sendAccountBlockSuccess(data.data));
      } else {
        dispatch(sendAccountBlockFailure(data));
      }
    }
  );
};

export const getFinancialList = () => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(getFinancialListStart());
  API.get("sandbox/interaction/inward/financial-institution-list").then(
    (response) => {
      const { data, ok } = response;
      responseHandler2(response);
      if (ok) {
        dispatch(getFinancialListSuccess(data.data));
      } else {
        dispatch(getFinancialListFailure(data));
      }
    }
  );
};
